/**
 * LCP Optimization - Ensure first images are not lazy loaded
 */

// Critical image optimization for better LCP
document.addEventListener('DOMContentLoaded', function() {
  'use strict';
  
  // Find and optimize first images that should not be lazy loaded
  function optimizeFirstImages() {
    // Get first few product cards (likely to be LCP candidates)
    const firstCards = document.querySelectorAll('.card-wrapper:nth-child(-n+4) img[loading="lazy"]');
    
    firstCards.forEach(function(img, index) {
      if (index < 2) { // First 2 images
        img.removeAttribute('loading');
        img.setAttribute('fetchpriority', 'high');
        
        // Ensure immediate loading
        if (img.dataset.src && !img.src) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      }
    });
    
    // Optimize hero/banner images
    const heroImages = document.querySelectorAll('.hero img, .banner img, .slideshow img');
    heroImages.forEach(function(img, index) {
      if (index === 0) {
        img.removeAttribute('loading');
        img.setAttribute('fetchpriority', 'high');
      }
    });
  }
  
  // Preload LCP candidate images
  function preloadLCPCandidates() {
    const lcpCandidates = document.querySelectorAll('.card-wrapper:first-child img, .hero img:first-child');
    
    lcpCandidates.forEach(function(img) {
      if (img.src || img.dataset.src) {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = img.src || img.dataset.src;
        
        // Add srcset if available
        if (img.srcset) {
          link.setAttribute('imagesrcset', img.srcset);
        }
        
        document.head.appendChild(link);
      }
    });
  }
  
  // Run optimizations
  optimizeFirstImages();
  preloadLCPCandidates();
  
  console.log('LCP optimization applied');
});